import { createOutcomeEvent } from '../../../utils/EventProviders/EgClickstreamUtil';
import { addressFields } from '../../../utils/AddressUtil';
import { getCookie } from '../../../utils/CookieUtil';
import { getFuzzyLatLng } from '../../../utils/LocationUtil';

const buildPayload = (props) => {
    const {
        trustPayload,
        // app props
        fingerprint, locale,
        // lyp props
        bedroomCount,
        bathroomCount,
        // experiment props
        isAddressV2,
        productListingMigration,
        // location props
        address,
        serverAddressValidation,
        latLng, geocoderLatLng,
        partialMatch,
        phoneNumber,
        phoneCountryCode,
        phoneCountryCodeDigits
    } = props;
    const parsedAddress = addressFields(address, productListingMigration);
    const duaid = getCookie('DUAID');
    const saveLocation = !geocoderLatLng.error;
    const testPropertyFeatureEnabled = false;
    const { lat, lng } = latLng;

    const { fuzzy } = getFuzzyLatLng(
        true,
        serverAddressValidation,
        latLng,
        '',
        partialMatch
    );

    return {
        details: {
            bedrooms: bedroomCount,
            bathrooms: bathroomCount,
            // ULX property types don't match Vrbo property types...
            // ...so default to HOUSE like we did in LYP
            propertyType: bedroomCount === 0 ? 'STUDIO' : 'HOUSE'
        },
        address: {
            ...parsedAddress,
            latitude: lat,
            longitude: lng,
            fuzzy,
            isAddressV2
        },
        // Include phone fields in payload (matches backend PropertyRequest model)
        phoneNumber: phoneNumber || '',
        phoneCountryCode: phoneCountryCode || '',
        phoneCountryCodeDigits: phoneCountryCodeDigits || '',
        locale,
        fingerprint,
        saveLocation,
        testPropertyFeatureEnabled,
        duaid,
        trustPayload
    };
};

const onComplete = (props) => ({ data }) => {
    const {
        pageName,
        setCreatedPropertyTriad,
        setExpediaId,
        setInternalUser,
        trigger,
        pageFlow,
        sendEloquaData,
        clearEloquaData,
        competitorLinkValue,
        // lead props
        newSupplier
    } = props;
    if (data.createProperty.isRedirect) {
        window.location.href = data.createProperty.route;
    } else {
        const propertyToCreate = buildPayload(props);
        if (competitorLinkValue) {
            sendEloquaData({
                link: competitorLinkValue,
                expediaId: data.createProperty.expediaId,
                address: {
                    address1: propertyToCreate.address.address1,
                    address2: propertyToCreate.address.address2,
                    city: propertyToCreate.address.city,
                    stateProvince: propertyToCreate.address.stateProvince,
                    postalCode: propertyToCreate.address.postalCode,
                    country: propertyToCreate.address.country,
                    longitude: propertyToCreate.address.longitude,
                    latitude: propertyToCreate.address.latitude
                }
            });
        }
        setCreatedPropertyTriad(data.createProperty.listingTriad);
        setExpediaId(data.createProperty.expediaId);
        setInternalUser(data.createProperty.isCreatedByInternalUser);
        trigger('listingOnboardingStarted', {
            eventlistingids: data.createProperty.listingTriad,
            newsupplier: newSupplier.toString()
        });
        clearEloquaData();
        trigger('outcome', createOutcomeEvent('property_creation.succeeded', pageName));
        pageFlow.next(pageName);
    }
};

const onError = (props) => (error) => {
    const {
        // context props
        trigger,
        // page name
        pageName,
        // dispatch props
        setCreatePropertyError
    } = props;
    trigger('outcome', createOutcomeEvent('property_creation.failed', pageName, `${pageName}.CreateProperty`));
    const errorMessage = error.graphQLErrors?.[0]?.message || 'Unknown error';
    setCreatePropertyError(errorMessage);
};

export {
    // eslint-disable-next-line import/prefer-default-export
    buildPayload,
    onComplete,
    onError
};
